import React, { useState } from 'react'
import { Card, Col, Row } from 'antd'
import './style.css'
import AddCar from './AddCar'
import CarList from './CarList'
import { FaChevronLeft } from "react-icons/fa6";
import { Link } from 'react-router-dom'


const MyGarage = () => {
  const [refreshFeed, setRefreshFeed] = useState(false)

  const handleRefreshFeed = () => {
    setRefreshFeed(true)
    setTimeout(() => {
      setRefreshFeed(false)
    }, 2000);
  }


  return (
    <Row id='car'>
      <Col md={24} sm={24} xs={24} className="md:px-20 sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6">
        <div className='flex justify-between mb-4'>
          <h5 className='heading-5 text-slate-600 font-semibold mb-0'>My Garage</h5>
          <Link to='/' className='cursor-pointer flex items-center'>
            <FaChevronLeft className='text-primary bg-white p-2 rounded-full text-3xl' />
            <small className='ml-2 font-medium'>Back</small>
          </Link>
        </div>
        <Card bordered={false} className='p-0'>
          <Row>
            <AddCar refreshFeed={handleRefreshFeed} />
          </Row>
          <Row className='md:mb-4 sm:mb-4 mb-6'>
            <CarList refreshFeed={refreshFeed} refreshFeedHandler={handleRefreshFeed} />
          </Row>
        </Card>
      </Col>
    </Row>
  )
}

export default MyGarage